export const DWOLLA_BUSINESS_TYPES = {
  SOLE_PROPRIETORSHIP: 'soleProprietorship',
  CORPORATION: 'corporation',
  LLC: 'llc',
  PARTNERSHIP: 'partnership',
};
